import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface DeleteBusinessUnitFacilities {
  actionName: 'deleteBusinessUnitFacilities';
  request: mtechnavi.api.company.IBusinessUnitFacilities;
}

// 品質管理削除
export const execDeleteBusinessUnitFacilities = async (
  worker: AppSaveWorker,
  request: mtechnavi.api.company.IBusinessUnitFacilities
) => {
  const fullMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/DeleteBusinessUnitFacilities';

  await worker.invokeListRequest<
    mtechnavi.api.company.IDeleteBusinessUnitFacilitiesRequest,
    void
  >(fullMethodName, {
    businessUnitFacilities: request,
  });
};
